import { render, staticRenderFns } from "./createNetworkInterfaceActivity.vue?vue&type=template&id=2f1483a6"
import script from "./createNetworkInterfaceActivity.vue?vue&type=script&lang=js"
export * from "./createNetworkInterfaceActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports